import { render, staticRenderFns } from "./Anonymous.vue?vue&type=template&id=3048963e"
import script from "./Anonymous.vue?vue&type=script&lang=js"
export * from "./Anonymous.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3048963e')) {
      api.createRecord('3048963e', component.options)
    } else {
      api.reload('3048963e', component.options)
    }
    module.hot.accept("./Anonymous.vue?vue&type=template&id=3048963e", function () {
      api.rerender('3048963e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/Anonymous.vue"
export default component.exports